module.exports = __webpack_public_path__ + "media/concept_stage-8f637b4dd7156b5b3ae7e2f0606fdeb6.svg";